import React from 'react';
import PropTypes from 'prop-types';
import styles from './PaymentMethodSelection.scss';
import PaymentMethodButton from '../PaymentMethodButton';
import { filterSupportedPaymentMethods } from '../../utils/CashierUtils';

export default function PaymentMethodSelection({ paymentTypes, paymentMethods, onSelectPayment, paymentMetadata }) {
  const hasPaymentMethods = paymentMethods.length > 0;

  return (
    <div className={styles.content} data-hook="payment-method-buttons">
      {!hasPaymentMethods &&
        paymentTypes.map(type => (
          <PaymentMethodButton
            dataHook={`payment-method-${type}-button`}
            key={type}
            type={type}
            onClick={onSelectPayment}
          />
        ))}

      {hasPaymentMethods &&
      filterSupportedPaymentMethods(paymentMethods).map(paymentMethod => {
          const type = paymentMethod.paymentMethod;
          const metadata = paymentMetadata.methods.find(pm => pm.id === type) || {};

          return (
            <PaymentMethodButton
              dataHook={`payment-method-${type}-button`}
              key={type}
              type={type}
              svgUrl={paymentMethod.methodIcon}
              onClick={onSelectPayment}
              title={metadata.title || type}
            />
          );
        })}
    </div>
  );
}

PaymentMethodSelection.displayName = 'PaymentMethodSelection';

PaymentMethodSelection.propTypes = {
  paymentTypes: PropTypes.array,
  paymentMethods: PropTypes.array,
  onSelectPayment: PropTypes.func,
  paymentMetadata: PropTypes.object,
};

PaymentMethodSelection.defaultProps = {
  paymentTypes: [],
  paymentMethods: [],
  paymentMetadata: { methods: [] },
};
